import { daysUntilNextMonth } from '../dates';
var ONE_DAY_IN_SECONDS = 60 * 60 * 24;
export var REFRESHMENTS_USER_DISMISSED_PAYMENT_FAILURE_PAGE_COOKIE_TTL = (daysUntilNextMonth() - 1) * ONE_DAY_IN_SECONDS;
export var SHOW_REFRESHMENTS_ONBOARDING_TOUR_COOKIE_TTL = 600;
var CookieName;
(function (CookieName) {
    // Indicates the number of finished sharing.
    CookieName["REFRESHMENT_SHARING_STEP_COOKIE"] = "refreshment_sharing_step";
    // Controls the Onboarding modal experiment.
    CookieName["SHOW_REFRESHMENTS_ONBOARDING_TOUR_COOKIE"] = "ip_refreshments_show_upgrader_onboarding_tour";
    CookieName["SHOW_REFRESHMENTS_NEWBIES_ONBOARDING_TOUR_COOKIE"] = "ip_refreshments_show_onboarding_tour";
    // Indicates when user updated the Payment Method to show the Payment Failure Notification.
    CookieName["REFRESHMENTS_PAYMENT_UPDATED_COOKIE"] = "REFRESHMENT_PAYMENT_UPDATED";
    // Indicate if user can see Payment Failure page or not.
    CookieName["REFRESHMENTS_USER_DISMISSED_PAYMENT_FAILURE_PAGE_COOKIE"] = "ip_refreshments_user_dismissed_payment_failure_page";
    // Cookies used on the creation subscription process and notifications
    CookieName["REFRESHMENTS_SUCCESS_SUB"] = "REFRESHMENTS_SUCCESS_SUB";
    CookieName["REFRESHMENTS_ERROR_SUB"] = "REFRESHMENTS_ERROR_SUB";
})(CookieName || (CookieName = {}));
export default CookieName;
